import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-job-profile-page',
  templateUrl: './job-profile-page.component.html',
  styleUrls: ['./job-profile-page.component.css']
})
export class JobProfilePageComponent implements OnInit {

  @Input() $transition$:any;

  stateParams:any;
  breadCrumbLabel: any;
  breadCrumbStateAddress: any;
  jobId: any;

  constructor(
    public $state: StateService
  ) { }

  ngOnInit() {
    this.stateParams = this.$transition$.params();
    //variables
    this.breadCrumbLabel = 'Requisitions';
    this.breadCrumbStateAddress = 'missioncontrol.requisitions';
    this.jobId = "5d627b8d80ee226eb8c0762e";
  }


  redirectToBreadCrumbStateUrl() {
    this.redirectToUrl(this.breadCrumbStateAddress, true);
  }

  redirectToUrl(url, isReloadRequired) {
    this.$state.go(url, null, { reload: isReloadRequired });
  }

}
